// import Layer from './Layer';
import TileLayer from './tile/TileLayer';
// import GroupTileLayer from './tile/GroupTileLayer';
// import WMSTileLayer from './tile/WMSTileLayer';
// import CanvasTileLayer from './tile/CanvasTileLayer';
// import ImageLayer from './ImageLayer';
import OverlayLayer from './OverlayLayer';
import VectorLayer from './VectorLayer';
// import CanvasLayer from './CanvasLayer';
// import ParticleLayer from './ParticleLayer';
// import TileSystem from './tile/tileinfo/TileSystem';
// import TileConfig from './tile/tileinfo/TileConfig';

export {
  // Layer,
  TileLayer,
  // GroupTileLayer,
  // WMSTileLayer,
  // CanvasTileLayer,
  // ImageLayer,
  OverlayLayer,
  VectorLayer,
  // CanvasLayer,
  // ParticleLayer,
  // TileSystem,
  // TileConfig
};



// WEBPACK FOOTER //
// ./src/layers/index.js